module.exports = __webpack_public_path__ + "static/img/Weight Management.51aed68a.svg";